module.exports = __webpack_public_path__ + "img/pic1.80d48ed0.jpg";